/**
 * This file contains configuration constants related to onboarding features in the application.
 */

/** */
export const CIRCUITS_ONBOARDING_EXPIRATION_DATE = "2026-10-30";

/** Velocity-based 1RM onboarding (dashboard modal, hotspots, tooltips) stops showing 2 weeks after its 2026-11-04 release. */
export const VELOCITY_ONBOARDING_EXPIRATION_DATE = "2026-11-18";
